import React, {Component} from 'react';
import { connect } from "react-redux";
import { Row, Col, Card, CardHeader, Container} from "reactstrap";
import CastConfigForm from "../CastConfigForm/CastConfigForm";
import {createCastConfig} from '../../../actions/actionCast';

class CreateCastConfig extends Component {
    constructor (props){
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <div className="mt-4">
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Create Casting Config</strong>
                                </CardHeader>
                                <CastConfigForm
                                    createCastConfig={this.props.createCastConfig}/>
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}


export default connect(state =>
        ({
            cast_configs: state.cast.cast_configs || [],
        }),
dispatch =>
    ({
        createCastConfig: (data) => dispatch(createCastConfig(data))
    }))(CreateCastConfig);




// WEBPACK FOOTER //
// ./src/views/CastConfig/CreateCastConfig/CreateCastConfig.js